<template>
  <div 
    :class="'header ' + 
        (large ? 'large' : '') + 
        (twoLine ? 'two-line' : '')"
    :style="{'--base-color': color}"
   >
    <v-icon 
        v-if="icon"
        class="announcement-icon"
    >
        {{icon}}
    </v-icon>
    <div class="announcement-title">
        <p class="announcement-title-text">
            {{ text }}
        </p>
    </div>
  </div>
</template>

<script>
  export default {
    name: "Header",

    props: {
        large: {
            type: Boolean,
            default: false
        },
        color: {
            type: String,
            default: 'white'
        },
        twoLine: {
            type: Boolean,
            default: false,
        },
        text: String,
        icon: String,
    },
  }
</script>

<style scoped>
    .header {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        margin-top: 1vw;
        margin-bottom: 3%;
    }

    .header.two-line {
        flex-direction: column;
        justify-content: flex-start;
        align-items: flex-start;
    }

    .announcement-title {
        display: inline-block;
        margin: 0.9vh 0.5vw 0vh 0vw;
        flex-grow: 4;
    }

    .announcement-title-text {
        font-weight: bold;
        font-size: 2.5vw;
        margin-bottom: 0;
        color: var(--base-color);
        line-height: 1.2;
    }

    .large .announcement-title-text {
        font-size: 5vw;
    }

    .announcement-icon {
        background-color: var(--base-color);
        font-size: 1.9vw !important;
        padding: 0.4em;
        border-radius: 50%;
        color: white !important;
        margin-right: 1.5vw;
    }

    .large .announcement-icon,
    .two-line .announcement-icon
     {
        font-size: 5vw !important;
        margin-right: 2vw;
    }

    .two-line .announcement-icon {
        margin-top: 2%;
        margin-bottom: 5%;
    }
</style>
